'use client';
import { projectFileAttachments } from '#pplx/frontend/apps/ask/composer-sdk-plugins/file-attachments/internal/fileAttachmentProjection.js';
import { useFileAttachmentIngress } from '#pplx/frontend/apps/ask/composer-sdk-plugins/file-attachments/internal/useFileAttachmentIngress.js';
import { useFileAttachmentPlugin } from '#pplx/frontend/apps/ask/composer-sdk-plugins/file-attachments/internal/useFileAttachmentPlugin.js';
import { useFileAttachmentState } from '#pplx/frontend/apps/ask/composer-sdk-plugins/file-attachments/internal/useFileAttachmentState.js';
import { useDefaultUploadGate } from '#pplx/frontend/apps/ask/hooks/file-attachments-hooks/useDefaultUploadGate.js';
import { useMemo } from 'react';
/** Builds the attachment plugin and exposes successfully uploaded URLs for submission. */
export function useFileAttachmentsPlugin({ uploadsEnabled, attachmentActionsEnabled, showFileMetadata, presentation, isFollowUp = false, onDismissError: observeDismissError, onOversizedTextPasted, onPreviewAttachment, onUploadAttempted, oversizedText = 'discard', renderAttachmentNotice, reason, uploadPolicy, }) {
    const gateUploadFile = useDefaultUploadGate({
        checkUploadFile: uploadPolicy.gate.checkUploadFile,
        isFollowUp,
    });
    const { addAttachments, attachmentMetadataById, errorMessage, files, hasUploadFailure, hydrateAttachments, onDismissError, onRemoveFile, removeAttachments, removedIdsRef, reset, setError, setFiles, setAttachmentMetadataById, } = useFileAttachmentState({ onDismissError: observeDismissError });
    const { uploadCloudFiles, uploadFileAsAttachment, onDropItems, onFilesSelected } = useFileAttachmentIngress({
        disabled: !uploadsEnabled,
        files,
        gateUploadFile,
        onUploadAttempted,
        reason,
        removedIdsRef,
        setError,
        setFiles,
        setAttachmentMetadataById,
        uploadPolicy,
    });
    const { attachmentUrls, fileAttachments, hasImageAttachments, isUploading, submitUploads, fileDescriptors, } = useMemo(() => projectFileAttachments({ attachmentMetadataById, files }), [attachmentMetadataById, files]);
    const plugin = useFileAttachmentPlugin({
        uploadsEnabled,
        attachmentActionsEnabled,
        showFileMetadata,
        presentation,
        errorMessage,
        files,
        gateUploadFile,
        onDismissError,
        onDropItems,
        onFilesSelected,
        onOversizedTextPasted,
        onPreviewAttachment,
        onRemoveFile,
        oversizedText,
        uploadedAttachmentCount: attachmentUrls.length,
        renderAttachmentNotice,
        uploadPolicy,
    });
    return {
        uploadCloudFiles,
        uploadFileAsAttachment,
        addAttachments,
        attachmentUrls,
        fileAttachments,
        hasImageAttachments,
        hasUploadFailure,
        hydrateAttachments,
        isUploading,
        plugin,
        removeAttachments,
        reset,
        submitUploads,
        fileDescriptors,
    };
}
//# sourceMappingURL=index.js.map